document.addEventListener('DOMContentLoaded', function () {

  if (!window.fetch || typeof Shopify === 'undefined') return;

  const GIFT_KEYBOARD_VARIANT_ID = 10233412124971; // 特典A
  const GIFT_OTHER_VARIANT_ID    = 10233411404075; // 特典B

  const TAG_KEYBOARD = 'as_gift_keyboard';
  const TAG_OTHER    = 'as_gift_other';

  // --- 商品フォームに hidden input を自動追加 ---
  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {

    const productTags = form.dataset.productTags?.split(',') || [];

    // keyboardタグがある場合
    if (productTags.includes(TAG_KEYBOARD)) {
      if (!form.querySelector('input[name="properties[_gift_type]"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_gift_type]';
        input.value = 'keyboard';
        form.appendChild(input);
      }
    }

    // otherタグがある場合
    if (productTags.includes(TAG_OTHER)) {
      if (!form.querySelector('input[name="properties[_gift_type]"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_gift_type]';
        input.value = 'other';
        form.appendChild(input);
      }
    }

  });

  // --- カート自動特典追加関数 ---
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
  }

  async function updateGifts() {
    const cart = await getCart();
    if (!cart.items.length) return;

    let needKeyboard = 0, needOther = 0;
    let currentKeyboard = 0, currentOther = 0;

    cart.items.forEach(item => {

      if (item.variant_id === GIFT_KEYBOARD_VARIANT_ID) { currentKeyboard += item.quantity; return; }
      if (item.variant_id === GIFT_OTHER_VARIANT_ID) { currentOther += item.quantity; return; }

      if (item.properties?._gift_type === 'keyboard') needKeyboard += item.quantity;
      if (item.properties?._gift_type === 'other')    needOther += item.quantity;
    });

    const add = [];
    if (needKeyboard > currentKeyboard) add.push({ id: GIFT_KEYBOARD_VARIANT_ID, quantity: needKeyboard - currentKeyboard });
    if (needOther > currentOther)       add.push({ id: GIFT_OTHER_VARIANT_ID, quantity: needOther - currentOther });

    if (add.length) await addItems(add);
  }

  // --- 初回 & Ajax カート対応 ---
  updateGifts();
  document.addEventListener('cart:updated', updateGifts);
});
